module.exports = __webpack_public_path__ + "img/PUREHEALS2.e2a81de7.jpg";